;(function(){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _props;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'CardCharged',
  props: (_props = {
    headerTitle: {
      type: String,
      default: 'Verification Charge Sent'
    },
    timestamp: {
      type: String,
      default: ""
    },
    displayCardNumber: {
      type: String,
      default: ""
    },
    successMessage: {
      type: String,
      default: 'Card has been charged'
    },
    chargeMessage: {
      type: String,
      default: "We've successfully charged a small verification amount to your card."
    },

    itemLabel: {
      type: String,
      default: 'Item'
    },
    verificationCharge: {
      type: String,
      default: 'Verification Charge'
    },
    cardLabel: {
      type: String,
      default: 'Card No.'
    },
    timestampLabel: {
      type: String,
      default: 'Time stamp'
    }
  }, (0, _defineProperty3.default)(_props, 'timestamp', {
    type: String,
    default: 'June 9, 2025 00:00:00'
  }), (0, _defineProperty3.default)(_props, 'noChargeText', {
    type: String,
    default: "Still don't see it?"
  }), (0, _defineProperty3.default)(_props, 'tryDifferentCardText', {
    type: String,
    default: 'Try different Card'
  }), (0, _defineProperty3.default)(_props, 'nextStepsTitle', {
    type: String,
    default: 'Next Steps:'
  }), (0, _defineProperty3.default)(_props, 'nextSteps', {
    type: Array,
    default: function _default() {
      return ['Open your banking app or statement when you receive the  notification of this charge.', 'Find the charge and note the 3-character code that appears immediately before the merchant name “ECITIZEN” (for example: AB3ECITIZEN → code is AB3).', 'Return here and enter that 3-character code.'];
    }
  }), (0, _defineProperty3.default)(_props, 'infoMessage', {
    type: String,
    default: "Usually appears within 5-30 minutes. We'll email you a reminder link if you don't complete transaction within 12 hours."
  }), (0, _defineProperty3.default)(_props, 'comeBackButtonText', {
    type: String,
    default: 'Come back'
  }), (0, _defineProperty3.default)(_props, 'confirmButtonText', {
    type: String,
    default: 'Confirm Now'
  }), _props),
  methods: {
    onComeBack: function onComeBack() {
      this.$emit('comeBackLater');
    },
    onConfirmNow: function onConfirmNow() {
      this.$emit('ConfirmVerification');
    },
    onTryDifferentCard: function onTryDifferentCard(event) {
      event.preventDefault();
      this.$emit('try-different-card');
    }
  }
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"grid grid-cols-12 gap-6"},[_c('div',{staticClass:"col-span-full lg:col-span-7 flex flex-col gap-8"},[_c('h2',{staticClass:"text-[#4c4f59] text-base font-semibold leading-normal text-left"},[_vm._v("\n       "+_vm._s(_vm.headerTitle)+"\n     ")]),_vm._v(" "),_c('div',{staticClass:"max-w-md mx-auto py-5 px-4 bg-[url(/iframev2/assets/img/png/card-bg.png)] bg-cover bg-no-repeat"},[_c('div',{staticClass:"text-white font-medium"},[_c('div',{staticClass:"flex items-center gap-2 mb-3 rounded-lg bg-white p-3 overflow-hidden"},[_c('div',{staticClass:"w-5 h-5 bg-green-500 rounded-full flex items-center justify-center"},[_c('svg',{attrs:{"width":"16","height":"17","viewBox":"0 0 16 17","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M3.33398 9.16675L6.00065 11.8334L12.6673 5.16675","stroke":"white","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}})])]),_vm._v(" "),_c('span',{staticClass:"font-semibold text-[#009247] text-sm"},[_vm._v(_vm._s(_vm.successMessage))])]),_vm._v(" "),_c('p',{staticClass:"text-sm mb-4"},[_vm._v("\n           "+_vm._s(_vm.chargeMessage)+"\n         ")]),_vm._v(" "),_c('div',{staticClass:"space-y-2 text-sm"},[_c('div',{staticClass:"flex justify-between"},[_c('span',{},[_vm._v(_vm._s(_vm.itemLabel))]),_vm._v(" "),_c('span',{},[_vm._v(_vm._s(_vm.verificationCharge))])]),_vm._v(" "),_c('div',{staticClass:"flex justify-between"},[_c('span',{},[_vm._v(_vm._s(_vm.cardLabel))]),_vm._v(" "),_c('span',{},[_vm._v("**** "+_vm._s(_vm.displayCardNumber))])]),_vm._v(" "),_c('div',{staticClass:"flex justify-between"},[_c('span',{},[_vm._v(_vm._s(_vm.timestampLabel))]),_vm._v(" "),_c('span',{},[_vm._v(_vm._s(_vm.timestamp))])])])])]),_vm._v(" "),_c('p',{staticClass:"text-center text-xs text-black/80 mt-4 hidden lg:block"},[_vm._v("\n       "+_vm._s(_vm.noChargeText)+"\n       "),_c('a',{staticClass:"hover:cursor-pointer text-[#3C65F5] font-medium",on:{"click":_vm.onTryDifferentCard}},[_vm._v(_vm._s(_vm.tryDifferentCardText))])])]),_vm._v(" "),_c('div',{staticClass:"col-span-full lg:col-span-5"},[_c('div',{staticClass:"p-4 inline-flex flex-col items-start gap-2"},[_c('p',{staticClass:"text-black/80 text-sm font-semibold leading-[21px]"},[_vm._v("\n         "+_vm._s(_vm.nextStepsTitle)+"\n       ")]),_vm._v(" "),_c('ol',{staticClass:"text-black text-xs font-medium leading-[18px] pl-4 !list-decimal",attrs:{"type":"1"}},_vm._l((_vm.nextSteps),function(step,index){return _c('li',{key:index},[_vm._v("\n           "+_vm._s(step)+"\n         ")])}),0),_vm._v(" "),_c('div',{staticClass:"bg-[#006FFF1A] rounded-lg p-3 flex items-start gap-2 text-[#5D5D5D]"},[_c('div',{staticClass:"size-5"},[_c('svg',{attrs:{"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M9.99935 1.66675C5.40768 1.66675 1.66602 5.40841 1.66602 10.0001C1.66602 14.5917 5.40768 18.3334 9.99935 18.3334C14.591 18.3334 18.3327 14.5917 18.3327 10.0001C18.3327 5.40841 14.591 1.66675 9.99935 1.66675ZM9.37435 6.66675C9.37435 6.32508 9.65768 6.04175 9.99935 6.04175C10.341 6.04175 10.6243 6.32508 10.6243 6.66675V10.8334C10.6243 11.1751 10.341 11.4584 9.99935 11.4584C9.65768 11.4584 9.37435 11.1751 9.37435 10.8334V6.66675ZM10.766 13.6501C10.7243 13.7584 10.666 13.8417 10.591 13.9251C10.5077 14.0001 10.416 14.0584 10.316 14.1001C10.216 14.1417 10.1077 14.1667 9.99935 14.1667C9.89102 14.1667 9.78268 14.1417 9.68268 14.1001C9.58268 14.0584 9.49102 14.0001 9.40768 13.9251C9.33268 13.8417 9.27435 13.7584 9.23268 13.6501C9.19102 13.5501 9.16602 13.4417 9.16602 13.3334C9.16602 13.2251 9.19102 13.1167 9.23268 13.0167C9.27435 12.9167 9.33268 12.8251 9.40768 12.7417C9.49102 12.6667 9.58268 12.6084 9.68268 12.5667C9.88268 12.4834 10.116 12.4834 10.316 12.5667C10.416 12.6084 10.5077 12.6667 10.591 12.7417C10.666 12.8251 10.7243 12.9167 10.766 13.0167C10.8077 13.1167 10.8327 13.2251 10.8327 13.3334C10.8327 13.4417 10.8077 13.5501 10.766 13.6501Z","fill":"#3532EA"}})])]),_vm._v(" "),_c('div',{staticClass:"flex flex-col gap-1"},[_c('p',{staticClass:"text-[10px] font-normal"},[_vm._v("\n             "+_vm._s(_vm.infoMessage)+"\n           ")])])])])]),_vm._v(" "),_c('div',{staticClass:"col-span-full lg:col-span-7"},[_c('p',{staticClass:"text-center text-xs text-black/80 mt-4 lg:hidden"},[_vm._v("\n       "+_vm._s(_vm.noChargeText)+"\n       "),_c('a',{staticClass:"text-[#3C65F5] font-medium",on:{"click":function($event){$event.preventDefault();return _vm.onTryDifferentCard.apply(null, arguments)}}},[_vm._v(_vm._s(_vm.tryDifferentCardText))])]),_vm._v(" "),_c('div',{staticClass:"flex gap-4 mt-6 lg:flex-row flex-col-reverse lg:max-w-xl"},[_c('button',{staticClass:"px-5 flex-1 btn-outline",on:{"click":_vm.onComeBack}},[_vm._v(_vm._s(_vm.comeBackButtonText))]),_vm._v(" "),_c('button',{staticClass:"px-5 flex-1 btn-primary !bg-[#1896D8]",on:{"click":_vm.onConfirmNow}},[_vm._v("\n         "+_vm._s(_vm.confirmButtonText)+"\n       ")])])])])}
__vue__options__.staticRenderFns = []
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-fa6b1fea", __vue__options__)
  } else {
    hotAPI.reload("data-v-fa6b1fea", __vue__options__)
  }
})()}